import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { Icon } from 'uikit'

import FileInputLink from './FileInputLink'

const UploadIcon = styled(Icon)`
  display: flex;
  font-style: normal;
`

const DropboxContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.gray};
  height: 226px;
`

const DescriptionSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
`

const FilesTypesOnly = styled.div`
  font-size: 13px;
  margin-top: 15px;
  color: ${props => props.theme.colors.silver};
`
const InitialUploadPrompt = ({ onAddAttachments }) => (
  <DropboxContainer>
    <UploadIcon icon="upload" size={70} />
    <DescriptionSection>
      <div>To attach files drag & drop here or</div>
      <FileInputLink onChange={onAddAttachments} multiple>
        select files from your computer
      </FileInputLink>
      <FilesTypesOnly>(JPEG, JPG, PNG, PDF only)</FilesTypesOnly>
    </DescriptionSection>
  </DropboxContainer>
)

InitialUploadPrompt.propTypes = {
  onAddAttachments: PropTypes.func.isRequired,
}

export default InitialUploadPrompt
